module.exports = __webpack_public_path__ + "img/fb0148b2dc6faca325e9c8830832230d.png";